import './styles/frontend.scss';
import './scripts/frontend';
